import { API } from "./api";

export const addEntertainmentVideo = (videos) =>
  API.post(`/entertainmentVideos`, videos);
export const getEntertainmentVideosByOwner = (onwerId) =>
  API.get(`/entertainmentVideos/owner/${onwerId}`);
export const getEntertainmentVideoById = (videoId) =>
  API.get(`entertainmentVideos/${videoId}`);
// api/entertainmentVideo.api.js
export const getOwnerScreensForVideo = (type, locationId) =>
  API.get(`entertainmentVideos/screens?type=${type}&locationId=${locationId}`);

export const updateEntertainmentVideo = (videoId, video) =>
  API.put(`/entertainmentVideos/${videoId}`, video);

export const deleteEntertainmentVideo = (videoId) =>
  API.delete(`/entertainmentVideos/${videoId}`);
export const getActiveMobileLocations = () =>
  API.get(`/mobileLocation?isActive=true`);
